module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/dribbble-profile.png?f022c79a6ceaa1aac2db026528f24716";